import Iconify from "@/components/iconify";
import { Box, Dialog, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import EditApiKeyForm from "./EditApiKeyForm";

CaktopApiKeyButtonEdit.propTypes = {
    apiKeyId: PropTypes.string,
}

export default function CaktopApiKeyButtonEdit({ apiKeyId }) {

    const [open, setOpen] = useState(false)

    const handleCloseDialog = () => {
        setOpen(false)
    }
    const handleOpenDialog = () => {
        setOpen(true)
    }

    return (
        <>
            <IconButton onClick={handleOpenDialog} color='warning' >
                <Tooltip title="Editar Chave API">
                    <Iconify icon="eva:edit-fill" />
                </Tooltip>
            </IconButton>

            <Dialog fullWidth maxWidth="sm" open={open} onClose={handleCloseDialog}>
                <Stack sx={{ bgcolor: 'background.default', minHeight: 450 }} p={2} gap={2}>
                    <Box display='flex' justifyContent='space-between' alignItems='center'>
                        <Typography variant="h4">Editar Chave API</Typography>
                        <IconButton onClick={handleCloseDialog}  >
                            <Iconify icon="eva:close-fill" />
                        </IconButton>
                    </Box>

                    <EditApiKeyForm open={open} apiKeyId={apiKeyId} handleCloseDialog={handleCloseDialog} />
                </Stack>
            </Dialog>
        </>
    )
}